module.exports = __webpack_public_path__ + "static/assets/4e5f4ef5c476e380a0002716324c2591.png";